import React, { Component } from "react";
import GoogleLogin from 'react-google-login';
import { make_request, after_auth } from "../Utils/Utils";
import google from "../../Assets/img/google_icon.png";

export default class LoginGoogle extends Component {
  
  state = {
    auth: false,
    user: { name: "", picture: "", email: "", birthday: "" , uid: "", provider: 'google'},
  };

  register = () => {};

  componentClicked = () => {};

  responseGoogle = async(response) => {
    if (response.status !== "unknown" && response.status !== "not_authorized" && response.profileObj !== undefined) {
      this.setState({
        auth: true,
        user: {
          email: response.profileObj.email,
          name: response.profileObj.name,
          uid: response.googleId,
          picture: response.profileObj.imageUrl,
          provider: 'google'
        },
      });
      const { user } = this.state;
      let edition_id = this.props.editionId;
      let responseJson = await make_request({
        path: "auth/google",
        method: "POST",
        body: {user, edition_id}
      });
      if (responseJson) {
        if (responseJson.status === "success") {
          // console.log(responseJson);
          after_auth(responseJson)
        } else {
          //  console.log("responseJson => " + JSON.stringify(responseJson));
          alert(responseJson.errors[0]);
        }
      }
    }
  };

  render() {
    let googleData;
    googleData = (
        <GoogleLogin
        clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
        autoLoad={false}
        render={renderProps => (
          <button className="btn btn-block btn-neutral" onClick={renderProps.onClick} disabled={renderProps.disabled}>
          <span className="btn-inner--icon">
            <img src={google} alt="" /> Login with Google
          </span>
          </button>
          
        )}
        buttonText="Login"
        onSuccess={this.responseGoogle}
        onFailure={this.responseGoogle}
        cookiePolicy={'single_host_origin'}
      />
        );
    return googleData;
  }
}
